import {useEffect} from 'react'

import {
  boxShapeSelector,
  boxShapeOptionsSelector,
  onLabelPropertyValueChange,
  packagesSelector,
  updateParcel,
  updateLabelConfig,
} from '../../../data/labelInfos/index.js'
import ConfigSelect from './ConfigSelect.js'
import {getState, useSelector} from '../../../store.js'
import {
  SHIPPER_DEPENDENT_PROPERTIES_FUNC,
  defaultValidLabelPropertiesFunc,
} from './useLabelProperty.js'
import {useLabelConfigContext} from '../LabelConfigContext.js'
import {getRates} from '../../../data/labelInfos/rateRequest.js'
import {SHIPPER_VENDORS} from '../../../common/constants/ShipperNames.js'

export function formatPackageTypeLabelProperty(shipperType) {
  return `packages[0].${shipperType}__box_shape`
}

export function packageTypeLabelPropertiesFunc(shipperType) {
  return shipperType ? [formatPackageTypeLabelProperty(shipperType)] : []
}

export async function updateBoxShapeAll(labelInfoID, shipperType, boxShape) {
  try {
    const packages = packagesSelector(getState(), {labelInfoID})

    packages.forEach((_, index) =>
      updateParcel(labelInfoID, index, {
        [`${shipperType}__box_shape`]: boxShape,
      }),
    )

    await getRates([labelInfoID])
  } catch (err) {
    updateLabelConfig(labelInfoID, {
      error_message: err.error_message || err.message,
    })
  }
}

export default function PackageType() {
  const {labelInfoID, shipperType} = useLabelConfigContext()
  const propertySpecs = PackageType.propertySpecList[0]
  const [labelProperty] = propertySpecs.labelPropertiesFunc(
    shipperType,
    labelInfoID,
  )

  const boxShape = useSelector((state) =>
    boxShapeSelector(state, {labelInfoID, shipperType, packagesIndex: 0}),
  )
  const options = useSelector((state) =>
    boxShapeOptionsSelector(state, {labelInfoID, shipperType}),
  )

  useEffect(() => {
    if (!boxShape && options[0]) {
      updateBoxShapeAll(labelInfoID, shipperType, options[0].value)
    }
  }, [shipperType, boxShape, options])

  const id = `${labelInfoID}__${labelProperty}`

  return (
    <ConfigSelect
      className="list__item--shipping-options flex-grow"
      id={id}
      value={boxShape}
      options={options}
      noEmptyOption
      onChange={(payload) => {
        updateBoxShapeAll(labelInfoID, shipperType, payload)

        onLabelPropertyValueChange(labelInfoID, labelProperty)
      }}
      Label={() => (
        <>
          <label className="label--bold" htmlFor={id}>
            Package Type<span className="required">*</span>
          </label>
        </>
      )}
      labelProperty={labelProperty}
      propertySpecs={propertySpecs}
      overrideLabel="Override other selected package types when preset is applied"
      overrideHelpTitle="Learn More"
      overrideHelpLink="https://support.ordoro.com/how-do-additive-vs-overwrite-presets-work-in-rate-shopping/"
    />
  )
}

PackageType.propertySpecList = [
  {
    validShipperTypes: SHIPPER_VENDORS,
    labelPropertiesFunc: packageTypeLabelPropertiesFunc,
    dependentPropertiesFunc: SHIPPER_DEPENDENT_PROPERTIES_FUNC,
    validLabelPropertiesFunc: defaultValidLabelPropertiesFunc,
  },
]
